import React, { useState } from 'react';
import './project.css';
import { SliderData } from '../../data/SliderData';
import { FaArrowAltCircleRight, FaArrowAltCircleLeft } from 'react-icons/fa';
import Seperator from '../../Common/Seperator/Seperator';

const Project = ({ slides }) => {
  const [current, setCurrent] = useState(0);
  const length = slides.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  if (!Array.isArray(slides) || slides.length <= 0) {
    return null;
  }

  return (
    <section className='slider'>
    <div className="slider-s">
    <div data-aos="fade-up" className="c-title"><Seperator/> <h2>Portfolio</h2><Seperator/></div>
     <div data-aos="fade-up" className="slider-cont">Recent Projects</div>
    </div>
      <FaArrowAltCircleLeft data-aos="fade-right" className='left-arrow' onClick={prevSlide} />
      <FaArrowAltCircleRight data-aos="fade-left" className='right-arrow' onClick={nextSlide} />
      {SliderData.map((slide, index) => {
        return (
          <div
            className={index === current ? 'slide active' : 'slide'}
            key={index}
          >
            {index === current && (
              <img src={slide.image} alt='travel' className='image' />
            )}
          </div>
        );
      })}
    </section>
  );
};

export default Project;